import { Button, Grid, withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import SelectDropdown from "components/SelectDropdown";
import { PrintIcon } from "features/shared/components";
import React, { useState } from "react";
import { useReactToPrint } from "react-to-print";
import { DATE_FORMATS, DATE_UNIT, DateUtils } from "shared/dateUtils";
import { DatePicker } from "../../shared/components";

export const ConciliationHeader = ({
  categoriesList,
  classes,
  componentRef,
  conciliationStartDate,
  endDate,
  onButtonClick,
  onSelectEndDate,
  onSelectFormChange,
  onSelectStartDate,
  selectedCategory,
  startDate,
}) => {
  const { t } = useTranslations();

  const [hasDateError, setHasDateError] = useState(false);

  const formattedStartDate = DateUtils.parse(startDate).format(
    DATE_FORMATS["DD/MM/YYYY"]
  );
  const formattedConciliationDate = DateUtils.parse(
    conciliationStartDate
  ).format(DATE_FORMATS["DD/MM/YYYY"]);

  /**
   * essa funcão é necessaria para o controle do estado do botao
   * pois o OnError do datepicker é uma funcao colateral e nao muda o status da pagina
   */
  const validateDateError = (e, type = "end") => {
    if (e.search("_") >= 0 || e === "") {
      setHasDateError(true);
      return;
    }

    const targetValueInstance = DateUtils.parse(e, DATE_FORMATS["DD-MM-YYYY"]);
    const lowerDateLimit = DateUtils.parse(startDate).subtract(
      1,
      DATE_UNIT.DAY
    );

    if (
      targetValueInstance.isBefore(lowerDateLimit) ||
      targetValueInstance.isAfter(endDate)
    ) {
      setHasDateError(true);
      return;
    }

    if (type === "end" && targetValueInstance.isBefore(startDate)) {
      setHasDateError(true);
      return;
    }

    if (type === "start" && targetValueInstance.isAfter(endDate)) {
      setHasDateError(true);
      return;
    }

    setHasDateError(false);
  };

  const handleApplyFilter = () => {
    onButtonClick(startDate, endDate);
  };

  const handlePrintPage = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Grid container direction="row" justify="space-between" alignItems="center">
      <Grid item xs={3} className={classes.selectInputWrapper}>
        <SelectDropdown
          id="animal-category-select"
          label={{ text: t("animalCategory:category") }}
          options={categoriesList}
          value={selectedCategory}
          onChange={onSelectFormChange}
        />
      </Grid>
      <Grid item xs={2}></Grid>
      <Grid item xs={5} style={{ position: "relative" }}>
        <div className={classes.filterContentWrapper}>
          <div className={classes.startDatePickerWrapper}>
            <DatePicker
              id="start-date-picker"
              minDate={conciliationStartDate}
              maxDate={endDate}
              onChangeDate={(e) => onSelectStartDate(e)}
              onChangeInputValue={(e) => validateDateError(e, "start")}
              label={t("common:fields.start-date")}
              maxDateMessage={t("common:validation.max-date")}
              minDateMessage={t(
                "conciliation:date-is-before-conciliation-date-message",
                { date: formattedConciliationDate }
              )}
              value={startDate}
            />
          </div>
          <div className={classes.endDatePickerWrapper}>
            <DatePicker
              id="end-date-picker"
              minDate={startDate}
              onChangeDate={(e) => onSelectEndDate(e)}
              onChangeInputValue={(e) => validateDateError(e, "end")}
              label={t("common:fields.end-date")}
              maxDateMessage={t("common:validation.max-date")}
              minDateMessage={t("common:validation.min-date", {
                date: formattedStartDate,
              })}
              value={endDate}
            />
          </div>
          <div className={classes.applyFilterButtonWrapper}>
            <Button
              id="apply-filter-button"
              onClick={handleApplyFilter}
              variant="contained"
              color="primary"
              disabled={hasDateError}
              className={classes.applyFilterButton}
            >
              {t("common:actions.edit-date")}
            </Button>
          </div>
          <div style={{ height: "80px" }}>
            <Button
              id="print-page-button"
              onClick={handlePrintPage}
              variant="contained"
              color="primary"
              className={classes.printButton}
            >
              <PrintIcon />
            </Button>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

const styles = () => ({
  applyFilterButtonWrapper: {
    height: "80px",
    position: "relative",
    marginLeft: "16px",
  },
  applyFilterButton: {
    float: "right",
    height: "36px",
    marginTop: "10px",
    borderRadius: "18px",
    fontFamily: "Roboto",
    fontSize: "13px",
    fontWeight: "500",
    minWidth: 128,
    boxShadow: "none",
    letterSpacing: "1.25px",
    textAlign: "center",
    color: "#ffffff",
  },
  printButton: {
    float: "right",
    height: "36px",
    marginTop: "10px",
    borderRadius: "18px",
    fontFamily: "Roboto",
    fontSize: "14px",
    minWidth: 56,
    fontWeight: "500",
    letterSpacing: "1.25px",
    textAlign: "center",
    color: "#ffffff",
    boxShadow: "none",
    marginLeft: "16px",
  },
  selectInputWrapper: {
    paddingBottom: "0.480em",
    marginLeft: "-0.5%",
  },
  filterContentWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "36px",
  },
  startDatePickerWrapper: {
    marginRight: "5%",
    height: "80px",
  },
  endDatePickerWrapper: {
    height: "80px",
  },
});

export default withStyles(styles)(ConciliationHeader);
